import { z } from 'zod';
import { DateLikeSchema, DecimalLikeSchema, EstadoSchema, IsoDateTimeSchema, NullableEmailSchema, NullableUrlSchema, UuidSchema, } from './common.js';
export const GuardiaSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1),
    cedula: z.string().nullable(),
    fechaNacimiento: DateLikeSchema.nullable(),
    telefono: z.string().nullable(),
    email: NullableEmailSchema,
    direccion: z.string().nullable(),
    contactoEmergencia: z.string().nullable(),
    puesto: z.string().nullable(),
    tipoFuncionario: z.string().nullable(),
    sucursalId: UuidSchema.nullable(),
    clienteId: UuidSchema.nullable(),
    fechaAlta: DateLikeSchema.nullable(),
    salarioBase: DecimalLikeSchema.nullable(),
    montoPorHora: DecimalLikeSchema.nullable(),
    jornal: DecimalLikeSchema.nullable(),
    estado: EstadoSchema.nullable(),
    avatarUrl: NullableUrlSchema,
    createdAt: IsoDateTimeSchema.nullable(),
});
// Shape enxuto para dropdowns/agrupamento por sucursal (Guardias por Sucursal,
// Registro de Turno, Inventario→Asignaciones). NÃO inclui salarioBase (salário
// mensal) nem PII (cedula/telefono/email/direccion) — só o operacional. jornal/
// montoPorHora ficam porque o cálculo de pago do registro de turno depende deles.
export const GuardiaOptionSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1),
    puesto: z.string().nullable(),
    sucursalId: UuidSchema.nullable(),
    clienteId: UuidSchema.nullable(),
    estado: EstadoSchema.nullable(),
    avatarUrl: NullableUrlSchema,
    montoPorHora: DecimalLikeSchema.nullable(),
    jornal: DecimalLikeSchema.nullable(),
});
// Resposta agregada de GET /guardias/por-sucursal (fix/096): UMA resposta
// substitui o fan-out paginado do FE em Guardias por Sucursal.
export const GuardiasPorSucursalResponseSchema = z.object({
    grupos: z.array(z.object({
        id: UuidSchema,
        nombre: z.string(),
        guardias: z.array(GuardiaOptionSchema),
    })),
    sinSucursal: z.array(GuardiaOptionSchema),
    totalGuardias: z.number().int().nonnegative(),
});
// avatarUrl é derivado server-side via upload (POST /:id/avatar); não aceitar no
// body de create/update evita mass-assignment de URL apontando para objeto alheio.
export const CreateGuardiaRequestSchema = GuardiaSchema.omit({
    id: true,
    createdAt: true,
    avatarUrl: true,
});
export const UpdateGuardiaRequestSchema = CreateGuardiaRequestSchema.partial();
export const TipoTurnoSchema = z.enum(['completo', 'medio', 'extendido', 'ausente']);
export const HorasTrabajadaSchema = z.object({
    id: UuidSchema,
    guardiaId: UuidSchema,
    clienteId: UuidSchema.nullable(),
    sucursalId: UuidSchema.nullable(),
    fecha: DateLikeSchema,
    hora: z.string().nullable(),
    horasNormales: DecimalLikeSchema.nullable(),
    horasExtras: DecimalLikeSchema.nullable(),
    horasNocturnas: DecimalLikeSchema.nullable(),
    tipoTurno: TipoTurnoSchema,
    multiplicadorPago: DecimalLikeSchema.nullable(),
    jornalAplicado: DecimalLikeSchema.nullable(),
    pagoCalculado: DecimalLikeSchema.nullable(),
    descripcion: z.string().nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateHorasRequestSchema = HorasTrabajadaSchema.omit({
    id: true,
    createdAt: true,
    multiplicadorPago: true,
    jornalAplicado: true,
    pagoCalculado: true,
});
export const UpdateHorasRequestSchema = CreateHorasRequestSchema.omit({
    guardiaId: true,
}).partial();
export const GuardiasPdfQuerySchema = z.object({
    sucursalId: UuidSchema,
});
// storagePath não é exposto ao cliente: o download passa por endpoint autenticado
// (GET /api/guardias/:id/documents/:docId/download), nunca por URL direta do MinIO.
export const PersonalDocumentSchema = z.object({
    id: UuidSchema,
    personalId: UuidSchema,
    fileName: z.string().nullable(),
    fileType: z.string().nullable(),
    fileSize: z.number().int().nonnegative().nullable(),
    uploadedBy: UuidSchema.nullable(),
    uploadedAt: IsoDateTimeSchema.nullable(),
});
//# sourceMappingURL=hr.js.map